import classNames from "classnames";
import { observer } from "mobx-react-lite";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { Button} from "reactstrap";
import { translationHookOptions } from "../../../app/localization/localization";
import { RootStoreContext } from "../../../app/stores/rootStore";

const ArrowButton = () => {
  const rootStore = useContext(RootStoreContext);
  const { theme } = rootStore.commonStore;
  const { ZwibblerUseArrowTool, isArrowEnabled, isZoomed, ZwibblerEnableReadOnlyMode} =
    rootStore.zwibblerStore;
  const [t] = useTranslation(["browse_page"], translationHookOptions);

  const handleClick = () => {
    if(isArrowEnabled)ZwibblerEnableReadOnlyMode();
    else ZwibblerUseArrowTool();
  };

  return (
    <>
      <Button
        id="freccia"
        className={classNames(
          "w-100 px-1 pt-1 pb-1 toolbarButton transparentButton",
          isArrowEnabled
            ? `${theme!.toolbarActiveIconColor}`
            : `${theme!.toolbarIconColor}`
        )}
        color=""
        disabled={isZoomed}
        onClick={() => handleClick()}
        style={{ position: "relative" }}
      >
        <i className="fas fa-long-arrow-alt-right iconToolbarButton"></i>
        <h6 className="textToolbarButton mb-0">{t("toolbar_arrow_button")}</h6>
      </Button>
    </>
  );
};

export default observer(ArrowButton);
